export function radioConfig({ colors }) {
    return {
        readOnly: {
            border: `1px solid ${colors.graphicSecondaryColorLight}`,
            checkedBG: colors.graphicSecondaryColorLight
        }
    };
}
